const DIRECTIONS = ["horizontal", "vertical"];
const MODES = ["left", "right", "top", "bottom", "alternate"];
const LABEL_POSITIONS = ["relative", "same"];
const DOTS = ["hollow", "solid"];
const LINES = ["solid", "dashed", "dotted"];
const POSITIONS = ["left", "right", "top", "bottom"];
export { DIRECTIONS, DOTS, LABEL_POSITIONS, LINES, MODES, POSITIONS };
